import DashboardIcon from '@mui/icons-material/Dashboard';
import SettingsIcon from '@mui/icons-material/Settings';
import StorageIcon from '@mui/icons-material/Storage';
import DescriptionIcon from '@mui/icons-material/Description';
import PeopleIcon from '@mui/icons-material/People';

export const HeaderList = [
    {
      key: 1,
      label: "Dashboard",
      path: "/dashboard",
      icon: <DashboardIcon sx={{ fontSize: 16 }} />
    },
    {
      key: 2,
      label: "Setup",
      path: "/setup",
      icon: <SettingsIcon sx={{ fontSize: 16 }} />
    },
    {
      key: 3,
      label: "Quality",
      path: "/quality",
      icon: <StorageIcon sx={{ fontSize: 16 }} />
    },
    {
      key: 4,
      label: "Reports",
      path: "/reports",
      icon: <DescriptionIcon sx={{ fontSize: 16 }} />
    },
    {
      key: 5,
      label: "Staff And Plant",
      path: "/staff_and_plant",
      icon: <PeopleIcon sx={{ fontSize: 16 }} />
    }
  ];

export const setupList = [
    {   
        key: 1,
        title: "CP Checklist",
        path: "/setup/cp-checklist",
        image: "/ConstructionProgressTemplate.png"
    },
    {
        key: 2,
        title: "QC Checklist",
        path: "/setup/qc-checklist",
        image: "/QCChecklistTemplate.png"
    },
    {
        key: 3,
        title: "Bill of materials",
        path: "/setup/bill-of-material",
        image: "/billOfMaterials.png"
    },
    // {
    //     key: 4,
    //     title: "Construction Progress Sequence",
    //     path: "/setup/construction-progress-sequence",
    //     image: "/ConstructionProgressTemplate.png"
    // },
    {
        key: 5,
        title: "Laydown & Scope",
        path: "/setup/laydown-and-scope",
        image: "/QCChecklistTemplate.png"
    }
]

export const staff_and_plant_List=[
    {
      title: "Staff List",
      path: "/staff_and_plant/staffList",
      image: "/staffList.png"
    },
    {
        title: "Plant List",
        path: "/staff_and_plant/plantList",
        image: "/plantList.png"
    },
    {
        title: "Work Hours",
        path: "/staff_and_plant/workHour",
        image: "/workHour.png"
    }
]

export const reportsList = [
  {
      title: "Summary",
      path: "/reports/summary",
      image: "/summary.png"
  },
  {
      title: "Install Stats",
      path: "/reports/install-stats",
      image: "/installStats.png"
  },
  // {
  //     title: "BOM By Block",
  //     path: "/reports/BomByBlock",
  //     image: "/billOfMaterials.png"
  // },
  //  {
  //     title: "Summarized Inventory Report",
  //     path: "/reports/summarized-inventory-report",
  //     image: "/installStats.png"
  // },
  {
    title:"Scope Allocated Per Laydown",
    path:"/reports/scope-allocated-per-laydown",
    image:"/summary.png"
  }
]

export const staffAndplantList = [
  {
    title: "Staff List",
    path: "staffList",
    image: "/staffList.png",
  },
  {
    title: "Plant List",
    path: "plantList",
    image: "/plantList.png",
  },
  {
    title: "Work Hours",
    path: "workHour",
    image: "/workHour.png",
  },
];



export const qualityList = [
  {
      title: "Logs & Checklists",
      path: "/quality/lock-and-unlock",
      image: "/QCPunchlist&Checksheets.png"
  },
  {
      title: "QC Punchlist",
      path: "/quality/qc-punchlist",
      image: "/QCChecklistTemplate.png"
  }
]

export const bomcolumns = [
  {
      "key": 1,
      "value": "part_number",
      "hidden": false
  },
  {
      "key": 2,
      "value": "part_description",
      "hidden": false
  },
//   {
//       "key": 3,
//       "value": "project_quantity",
//       "hidden": false
//   },
  {
      "key": 4,
      "value": "distribution",
      "children": [
         "Marked by completion of"
      ],
      "hidden": false
  },
  {
      "key": 5,
      "value": "installed",
      "children": [
          "Marked by completion of"
      ],
      "hidden": false
  }
]


export const punlistcolumns = [
  {
      "key": 1,
      "value": "time_stamp",
      "hidden": false
  },
  {
      "key": 2,
      "value": "block",
      "hidden": false
  },
  {
      "key": 3,
      "value": "section",
      "hidden": false
  },
  {
      "key": 4,
      "value": "row",
      "hidden": false
  },
  {
      "key": 5,
      "value": "scope",
      "hidden": false
  },
  {
      "key": 6,
      "value": "checkpoint",
      "hidden": false
  },
  {
      "key": 7,
      "value": "acceptance_crieteria",
      "hidden": false
  },
  {
      "key": 8,
      "value": "comments",
      "hidden": false
  },
  {
      "key": 9,
      "value": "photos",
      "hidden": false
  },
  {
      "key": 10,
      "value": "status",
      "hidden": false
  }
]

export const scopeReport = [
  {
      "key": 2,
      "value": "block",
      "hidden": false
  },
  {
    "key": 1,
    "value": "part_name",
    "hidden": false
  },
  {
    "key": 6,
    "value": "part_description",
    "hidden": false
  },
  {
      "key": 3,
      "value": "section",
      "hidden": false
  },
  {
      "key": 4,
      "value": "row",
      "hidden": false
  },
  {
      "key": 5,
      "value": "laydown",
      "hidden": false
  }
]


export const ItcandItrColumns = [
      {
          "key": 1,
          "value": "block",
          "hidden": false
      },
      {
          "key": 2,
          "value": "section",
          "hidden": false
      },
      {
          "key": 3,
          "value": "row",
          "hidden": false
      },
      {
          "key": 4,
          "value": "scope",
          "hidden": false
      }
]
